import IResult from '../../models/result/IResult';
import {
    ManagedWorkQueueBatchRequest,
    ManagedWorkQueueBatchResponse,
    ManagedWorkQueueRemovalRequest,
    ManagedWorkQueueSnapshot,
    ManagedWorkQueueType
} from '../../models/managedWorkQueues/ManagedWorkQueue';
import { sendGet, sendPost, sendPut } from './generic';

export const getManagedWorkQueues = (
    organizationId?: string,
    includeHistory: boolean = true
): Promise<IResult<ManagedWorkQueueSnapshot>> => {
    const organizationQuery = organizationId ? `&organizationId=${encodeURIComponent(organizationId)}` : '';
    return sendGet(`/managedWorkQueues?includeHistory=${includeHistory}${organizationQuery}`);
};

export const queueManagedModuleSyncBatch = (
    request: ManagedWorkQueueBatchRequest
): Promise<IResult<ManagedWorkQueueBatchResponse>> => sendPost('/managedWorkQueues/module-sync-batches', request);

export const queueManagedBackupPublishBatch = (
    request: ManagedWorkQueueBatchRequest
): Promise<IResult<ManagedWorkQueueBatchResponse>> => sendPost('/managedWorkQueues/backup-publish-batches', request);

export const reorderManagedWorkQueue = (
    queueType: ManagedWorkQueueType,
    organizationId: string,
    jobIds: string[]
): Promise<IResult<ManagedWorkQueueSnapshot>> => sendPut(`/managedWorkQueues/${queueType}/order`, {
    organizationId,
    jobIds
});

export const removeManagedWorkQueueJobs = (
    request: ManagedWorkQueueRemovalRequest
): Promise<IResult<ManagedWorkQueueSnapshot>> => sendPost('/managedWorkQueues/remove', request);
